export type BottomSheetState =
  | 'APPOINTMENT_FILTER'
  | 'CHOSE_NEW_ADDRESS'
  | 'GOOGLE_AUTO_COMPLETE';
